<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17GvfP8/tc-custom/9781504071802.jpg?1716663165625" alt="This image is the cover for the book Green Viper, The James Ryker Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Green Viper, The James Ryker Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A mysterious message sends ex-spy James Ryker to New York—where he’s caught between the FBI and a mob war . . .</b><br/><br/><i>I need your help. Call me.</i> Ex-intelligence agent James Ryker receives a coded message through a secret drop point, a means of communication known only to him and one other person. The problem is, that person is his ex-boss, Mackie . . . and he’s already dead.<br/><br/>But the cry for help is real, and it’s a request Ryker can’t refuse. Traveling to New York alone and without official sanction, Ryker has a single goal in mind, yet even he couldn’t have bargained for the violent world he’s soon embroiled in. Caught in the middle of spiraling chaos, with the FBI on one side and warring underworld bosses on the other, Ryker must put all of his skills to the test in order to come out on top and keep his word. In a world full of lies and deceit, loyalty is everything, and it’s time for James Ryker to pay his dues
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rob Sinclair
      </h2>
      
      <p class="authorDescription body article">Rob specialised in forensic fraud investigations at a global accounting firm for thirteen years. He began writing in 2009 following a promise to his wife, an avid reader, that he could pen an 'unputdownable' thriller. Since then, Rob has sold over a million copies of his critically acclaimed and bestselling thrillers in the Enemy, James Ryker and Sleeper series. His work has received widespread critical acclaim, with many reviewers and readers likening Rob's work to authors at the very top of the genre, including Lee Child and Vince Flynn.  Originally from the North East of England, Rob has lived and worked in a number of fast-paced cities, including New York, and is now settled in the West Midlands with his wife and young sons.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1bcf024e